export const insertBRNumberMask = (
  num: number,
  options: Intl.NumberFormatOptions = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
) => num?.toLocaleString('pt-br', options)
